<template>
  <div style="margin-top: 60px" class="home">
    <strong>{{ message }}</strong>
    <Loader :dialog-loader="dialogLoader" :message="message"></Loader>
  </div>
</template>
<script>
// NOTE: PaymentsCollection is also getting updated with the new z_closure_id
import { getSetOfPayments, getNextSetOfPayments } from "@/collections/payments";
import { saveZclousure } from "@/collections/zClousures";
import Loader from "@/components/common/Loader";
import moment from "moment";
import zClosureMixin from "@/mixins/dashboard/zClosureMixin";
export default {
  name: "UpdateZclousureCollection",
  components: {
    Loader
  },
  mixins: [zClosureMixin],
  data() {
    return {
      dialogLoader: true,
      cashCount: {
        fiveHundred: 0,
        twoHundred: 0,
        oneHundred: 0,
        fifty: 0,
        twenty: 0,
        ten: 0,
        five: 0,
        two: 0,
        one: 0,
        pointFifty: 0,
        pointTwenty: 0,
        pointTen: 0,
        pointZeroFive: 0,
        pointZeroTwo: 0,
        pointZeroOne: 0
      },
      changeCount: {
        fifty: 0,
        twenty: 0,
        ten: 0,
        five: 0,
        two: 0,
        one: 0,
        pointFifty: 0,
        pointTwenty: 0,
        pointTen: 0,
        pointZeroFive: 0,
        pointZeroTwo: 0,
        pointZeroOne: 0
      }
    };
  },
  created() {
    this.migratePaymentsZclosure();
  },
  computed: {
    message() {
      return this.dialogLoader
        ? this.$t("cart.updatingzClosuresSummaryCollection")
        : this.$t("cart.updated");
    },
    totalCashCount() {
      return (
        Number(this.cashCount.fiveHundred) * 500 +
        Number(this.cashCount.twoHundred) * 200 +
        Number(this.cashCount.oneHundred) * 100 +
        Number(this.cashCount.fifty) * 50 +
        Number(this.cashCount.twenty) * 20 +
        Number(this.cashCount.ten) * 10 +
        Number(this.cashCount.five) * 5 +
        Number(this.cashCount.two) * 2 +
        Number(this.cashCount.one) +
        Number(this.cashCount.pointFifty) * 0.5 +
        Number(this.cashCount.pointTwenty) * 0.2 +
        Number(this.cashCount.pointTen) * 0.1 +
        Number(this.cashCount.pointZeroFive) * 0.05 +
        Number(this.cashCount.pointZeroTwo) * 0.02 +
        Number(this.cashCount.pointZeroOne) * 0.01
      );
    },
    totalChangeCount() {
      return (
        Number(this.changeCount.fifty) * 50 +
        Number(this.changeCount.twenty) * 20 +
        Number(this.changeCount.ten) * 10 +
        Number(this.changeCount.five) * 5 +
        Number(this.changeCount.two) * 2 +
        Number(this.changeCount.one) +
        Number(this.changeCount.pointFifty) * 0.5 +
        Number(this.changeCount.pointTwenty) * 0.2 +
        Number(this.changeCount.pointTen) * 0.1 +
        Number(this.changeCount.pointZeroFive) * 0.05 +
        Number(this.changeCount.pointZeroTwo) * 0.02 +
        Number(this.changeCount.pointZeroOne) * 0.01
      );
    }
  },
  methods: {
    async migratePaymentsZclosure() {
      try {
        let first = await getSetOfPayments();

        let paymentByDate = {};
        while (!first.empty || first.exists) {
          let payments = [];
          first.forEach(doc => {
            let payment = doc.data();
            payment.id = doc.id;
            payments.push(payment);
          });
          payments = payments.map(x => ({
            ...x,
            payment_date: moment(x.payment_on.seconds * 1000).format(
              "DD-MM-YYYY"
            )
          }));

          payments.forEach(payment => {
            paymentByDate[payment.payment_date] // check if that array exists or not in paymentByDate object
              ? paymentByDate[payment.payment_date].push(payment) // just push
              : ((paymentByDate[payment.payment_date] = []),
                paymentByDate[payment.payment_date].push(payment)); // create a new array and push
          });

          let last = first.docs[first.docs.length - 1];
          first = await getNextSetOfPayments(last);
        }
        console.log("paymentByDate1", paymentByDate);
        this.updateZClosureSummary(paymentByDate);
      } catch (error) {
        this.setlogError(
          "get_next_set_of_payments/set_of_payments",
          "Obtained error message in migratePaymentsZclosure()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateZClosureSummary(payments) {
      if (Object.keys(payments).length <= 0) {
        return;
      }

      let zClosureId = 0;
      for (const [date, payments] of Object.entries(payments)) {
        zClosureId++;
        let opened_on = moment(date, "DD-MM-YYYY")
          .add(6, "hours")
          .toDate();
        let closed_on = moment(date, "DD-MM-YYYY")
          .add(28, "hours")
          .toDate();
        let orderSummary = await this.buildOrderSummary(opened_on, closed_on);
        let paymentSummary = await this.buildPaymentSummary(
          opened_on,
          closed_on,
          zClosureId
        );
        let obj = {
          closed_on: paymentSummary.closing_time,
          opened_on: orderSummary.opening_time,
          total_change_count_accumulated:
            paymentSummary.total_change_count_accumulated,
          total_invoiced_in_apple_pay:
            paymentSummary.total_invoiced_in_apple_pay,
          total_invoiced_in_google_pay:
            paymentSummary.total_invoiced_in_google_pay,
          total_invoiced_in_bizum: paymentSummary.total_invoiced_in_bizum,
          total_invoiced_in_datafono: paymentSummary.total_invoiced_in_datafono,
          total_invoiced_on_credit_card:
            paymentSummary.total_invoiced_on_credit_card,
          total_invoiced_in_cash: paymentSummary.total_invoiced_in_cash,
          z_closure_id: zClosureId,
          cash_count: this.cashCount,
          total_cash_count: this.totalCashCount,
          change_count: this.changeCount,
          total_change_count: this.totalChangeCount,
          cash_mismatch: null,
          totalOrders: orderSummary.orders.totalOrders,
          foodCount: orderSummary.orders.foodCount,
          drinkCount: orderSummary.orders.drinkCount,
          dessertCount: orderSummary.orders.dessertCount,
          foodAmount: orderSummary.orders.foodAmount,
          drinkAmount: orderSummary.orders.drinkAmount,
          dessertAmount: orderSummary.orders.dessertAmount,
          totalOrdersAmount: orderSummary.orders.totalOrdersAmount,
          totalAmount: paymentSummary.totalAmount,
          products: orderSummary.products,
          customers: orderSummary.customers,
          cntCash: paymentSummary.cntCash,
          cntCreditCard: paymentSummary.cntCreditCard,
          cntApplePay: paymentSummary.cntApplePay,
          cntGpay: paymentSummary.cntGpay,
          cntDatafono: paymentSummary.cntDatafono,
          cntBizum: paymentSummary.cntBizum
        };
        obj.cash_mismatch =
          Number(obj.total_invoiced_in_cash) -
          (Number(this.totalCashCount) -
            Number(obj.total_change_count_accumulated));
        console.log("zClosure2", zClosureId);
        obj.totalAmount > 0
          ? await saveZclousure(zClosureId, obj)
          : zClosureId--;
      }
      this.dialogLoader = false;
    }
  }
};
</script>
